import React, { useState } from 'react';

const LoginForm = ({ onLogin, isLoading }) => {
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    setError('');
    
    if (!password.trim()) {
      setError('Please enter a password');
      return;
    }
    
    onLogin(password);
  };

  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      padding: 'var(--space-xl)',
    }}>
      <div style={{
        backgroundColor: 'var(--color-surface)',
        padding: 'var(--space-2xl)',
        borderRadius: 'var(--radius-xl)',
        boxShadow: 'var(--shadow-lg)',
        width: '100%',
        maxWidth: '400px',
        border: '1px solid var(--color-border)'
      }}>
        <div style={{ textAlign: 'center', marginBottom: 'var(--space-xl)' }}>
          <img 
            src="/logo_euliaa.png" 
            alt="EULIAA logo" 
            style={{ 
              maxWidth: '180px', 
              height: 'auto',
              marginBottom: 'var(--space-lg)'
            }}
          />
          <h2 style={{ 
            color: 'var(--color-text)', 
            marginBottom: 'var(--space-sm)',
            fontSize: '1.375rem',
            fontWeight: '600',
            letterSpacing: '-0.025em'
          }}>
            Access Required
          </h2>
          <p style={{ 
            color: 'var(--color-text-secondary)', 
            fontSize: '0.9375rem',
            margin: 0
          }}>
            Enter the password to access protected content
          </p>
        </div>
        
        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: 'var(--space-lg)' }}>
            <label 
              htmlFor="password" 
              style={{ 
                display: 'block', 
                marginBottom: 'var(--space-sm)', 
                fontWeight: '500',
                color: 'var(--color-text)',
                fontSize: '0.875rem'
              }}
            >
              Password
            </label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              style={{
                width: '100%',
                padding: '12px 14px',
                border: '1px solid var(--color-border)',
                borderRadius: 'var(--radius-md)',
                fontSize: '1rem',
                boxSizing: 'border-box',
                transition: 'border-color var(--transition-fast), box-shadow var(--transition-fast)',
                outline: 'none'
              }}
              placeholder="Enter password"
              disabled={isLoading}
              autoFocus
              onFocus={(e) => {
                e.target.style.borderColor = 'var(--color-primary)';
                e.target.style.boxShadow = '0 0 0 3px var(--color-primary-light)';
              }}
              onBlur={(e) => {
                e.target.style.borderColor = 'var(--color-border)';
                e.target.style.boxShadow = 'none';
              }}
            />
          </div>
          
          {error && (
            <div style={{
              color: 'var(--color-error)',
              fontSize: '0.875rem',
              marginBottom: 'var(--space-lg)',
              padding: 'var(--space-sm) var(--space-md)',
              backgroundColor: 'var(--color-error-light)',
              borderRadius: 'var(--radius-md)',
              display: 'flex',
              alignItems: 'center',
              gap: 'var(--space-sm)'
            }}>
              <span>⚠️</span> {error}
            </div>
          )}
          
          <button
            type="submit"
            disabled={isLoading}
            className="btn btn-primary"
            style={{
              width: '100%',
              padding: '12px',
              fontSize: '1rem',
              fontWeight: '500',
              opacity: isLoading ? 0.7 : 1,
              cursor: isLoading ? 'not-allowed' : 'pointer',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: 'var(--space-sm)'
            }}
          >
            {isLoading && <span className="loading-spinner" style={{ width: '16px', height: '16px' }}></span>}
            {isLoading ? 'Signing in...' : 'Sign In'}
          </button>
        </form>
        
        <div style={{
          marginTop: 'var(--space-xl)',
          fontSize: '0.8125rem',
          color: 'var(--color-text-muted)',
          textAlign: 'center'
        }}>
          Learn more at{' '}
          <a 
            href="https://euliaa.eu/" 
            target="_blank"
            rel="noopener noreferrer"
            style={{ 
              color: 'var(--color-primary)', 
              textDecoration: 'none',
              fontWeight: '500'
            }}
          >
            euliaa.eu
          </a>
        </div>
      </div>
    </div>
  );
};

export default LoginForm;